<a3l-ui-snack-bar *ngFor="let item of items; let i = index" [item]="item" (close)="removeAt(i)"></a3l-ui-snack-bar>
